import React from 'react';
import { Card, CardContent, Typography, Avatar, Grid, Box, Container, useTheme, useMediaQuery } from '@mui/material';
import { Person, Email, Badge, Assignment } from '@mui/icons-material';
import { Persona } from '../../logic/domain/entities/persona';

/*
interface Persona {
  apellido: string;
  nombre: string;
  email: string | null;
  tipo: string;
  nroDoc: string;
}
*/
export const InfoCuenta: React.FC<{ user: Persona }> = ({ user }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const fullName = `${user.getNombre()} ${user.getApellido()}`;
  const initials = fullName.split(' ').map(n => n[0]).join('').toUpperCase();

  return (
    <Container 
      maxWidth={false} 
      disableGutters 
      sx={{ 
        height: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        p: 2
      }}
    >
      <Card 
        sx={{ 
          width: '100%', 
          maxWidth: 500, 
          boxShadow: 3, 
          borderRadius: 2,
          overflow: 'visible'
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Grid container spacing={2} alignItems="center" direction={isSmallScreen ? 'column' : 'row'}>
            <Grid item>
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  bgcolor: 'primary.main',
                  fontSize: '2rem',
                  mb: isSmallScreen ? 2 : 0
                }}
              >
                {initials}
              </Avatar>
            </Grid>
            <Grid item xs>
              <Typography variant="h5" component="div" gutterBottom align={isSmallScreen ? 'center' : 'left'}>
                {fullName}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" align={isSmallScreen ? 'center' : 'left'}>
                {user.getTipo()} : {user.getNroDoc()}
              </Typography>
            </Grid>
          </Grid>
          <Box sx={{ mt: 3 }}>
            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
              <Person sx={{ mr: 1, color: 'primary.main', fontSize: 28 }} />
              <strong>Nombre: </strong> <span>&nbsp;</span> {user.getNombre()}
            </Typography>
            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
              <Assignment sx={{ mr: 1, color: 'primary.main', fontSize: 28 }} />
              <strong>Apellido: </strong> <span>&nbsp;</span>{user.getApellido()}
            </Typography>
            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
              <Email sx={{ mr: 1, color: 'primary.main', fontSize: 28 }} />
              <strong>Email: </strong> <span>&nbsp;</span>{user.getEmail() || 'No disponible'}
            </Typography>
            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center' }}>
              <Badge sx={{ mr: 1, color: 'primary.main', fontSize: 28 }} />
              <strong>{user.getTipo()}: </strong><span>&nbsp;</span> {user.getNroDoc()}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};
